import React from 'react';
import PropTypes from 'prop-types';
import Arrow from '../../assets/arrow.svg';


class MobileWeekFilter extends React.Component {
  state = {
    actualWeek: this.props.selectedWeek,
    modalIsOpen: false,
  }

  static getDerivedStateFromProps(props, state) {
    if (props.selectedWeek !== state.actualWeek) {
      return {
        actualWeek: props.selectedWeek,
      };
    }
    return null;
  }

  handleChange = (event) => {
    this.setState({
      actualWeek: event.target.value,
      modalIsOpen: false,
    });
    this.props.onChange(event.target.value);
  }

  handleSelectClickArrowChange = () => {
    this.setState({
      modalIsOpen: true,
    });
  }

  render() {
    const { weeks, brandClass } = this.props;
    const { modalIsOpen, actualWeek } = this.state;
    return (
      <div className={`react-week-filter-mobile-select-container react-mozi-brand ${brandClass}`}>
        <div className="react-week-filter-mobile-select-value">{`${actualWeek.toString().slice(4)}. műsorhét`}</div>
        <Arrow className={`react-week-filter-mobile-arrow${modalIsOpen ? ' rotate' : ''}`} />
        <select
          className="react-week-filter-mobile-select"
          onChange={this.handleChange}
          onClick={this.handleSelectClickArrowChange}
          value={actualWeek}
        >
          {
            weeks.map(week => (
              <option key={week} value={week}>{week}</option>
            ))
          }
        </select>
      </div>
    );
  }
}

MobileWeekFilter.propTypes = {
  brandClass: PropTypes.string,
  weeks: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])),
  selectedWeek: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func.isRequired,
};

MobileWeekFilter.defaultProps = {
  weeks: null,
  selectedWeek: null,
  brandClass: 'react-artmozi',
};

export default MobileWeekFilter;
